export default "a835668830f544ca.svg"